// @ts-nocheck

import { useEffect, useState } from 'react';

const useGetHeightsFromRefs = (refs) => {
  const [heights, setHeights] = useState({});
  const nbHeights = Object.keys(heights).length;
  useEffect(() => {
    const tmpHeights = {};
    Object.keys(refs).forEach((id) => {
      if (refs[id].current) {
        const { height } = refs[id].current.getClientRect();
        if (!isNaN(height)) {
          tmpHeights[id] = Math.ceil(height, 10);
        }
      }
    });
    if (Object.keys(refs).length === Object.keys(tmpHeights).length) {
      setHeights(tmpHeights);
    }
  }, [refs, nbHeights]);
  return heights;
};

export default useGetHeightsFromRefs;
